export const getLabelByValue = (list, val) => {
	if (list?.length && val !== '') {
		return list.find(o => o.value === val)?.label
	}
	return ''
}

// 全局主题色彩settings.ts
// 全局主体色彩variabler.scss
export const globalColor = {
  primary: '#1677FF',
  success: '#30A46C',
  warning: '#FB9A0E',
  error: '#E5484D',
  info: 'rgba(0,0,0,0.25)',
}
export const badgeColor = globalColor


// 任务状态
export const taskStatusOpts = [
  {
    text: '已完成',
    value: 'RUNNING_SUCCESS'
  },
  {
    text: '失败',
    value: 'RUNNING_FAIL'
  },
  {
    text: '等待中',
    value: 'WAIT'
  },
  {
    text: '进行中',
    value: 'RUNNING'
  },
  {
    text: '已取消',
    value: 'STOP'
  },
  // {
  //   text: '创建任务失败',
  //   value: 'CREATE_FAIL'
  // }
]

export const tempTaskTypeOpts = [
  {
    text: '上传文件',
    value: 'UPLOAD_FILE',
    icon: 'task_scwj',
  },
  {
    text: '下载文件',
    value: 'COMPRESS',
    icon: 'task_yswj',
  },
  {
    text: '解压文件',
    value: 'DECOMPRESS',
    icon: 'task_jywj',
  },
]

// 任务类型
export const taskTypeOpts = [
  {
    text: '上传文件',
    value: 'UPLOAD_FILE',
    icon: 'task_scwj',
  },
  {
    text: '网站搬家',
    value: 'SITE_MOVE',
    icon: 'task_wzbj',
  },
  {
    text: '下载文件',
    value: 'COMPRESS',
    icon: 'task_yswj',
  },
  {
    text: '解压文件',
    value: 'DECOMPRESS',
    icon: 'task_jywj',
  },
  {
    text: '安装WordPress',
    value: 'APP_INSTALL',
    icon: 'task_azwzcx',
  },
  {
    text: '备份网站',
    value: 'WEB_BACKUP',
    icon: 'task_bfwz',
  },
  {
    text: '恢复网站',
    value: 'WEB_BACKUP_RESTORE',
    icon: 'task_hfwz',
  },
  {
    text: '备份数据库',
    value: 'DB_BACKUP',
    icon: 'task_hfdb',
  },
  {
    text: '恢复数据库',
    value: 'DB_BACKUP_RESTORE',
    icon: 'task_hfdb',
  },
  {
    text: '重置数据库',
    value: 'DB_EMPTY',
    icon: 'task_hfdb',
  },
]
